// apps/client/src/components/common/PeriodSelector.tsx
// Yahoo Finance-style relative time period selector for the main dashboard

import React from 'react';
import type { RelativePeriod } from '../../types';

interface PeriodSelectorProps {
  selected: RelativePeriod;
  onChange: (period: RelativePeriod) => void;
  disabled?: boolean;
}

const PERIOD_OPTIONS: Array<{ value: RelativePeriod; label: string }> = [
  { value: '3M', label: '3M' },
  { value: '6M', label: '6M' },
  { value: 'YTD', label: 'YTD' },
  { value: '1Y', label: '1Y' },
  { value: '2Y', label: '2Y' },
  { value: '5Y', label: '5Y' },
  { value: 'ALL', label: 'ALL' },
];

const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  selected,
  onChange,
  disabled = false,
}) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-400 mb-1">
        Time Period
      </label>
      <div className="flex gap-x-1 bg-gray-700 border-gray-600 rounded-md p-1">
        {PERIOD_OPTIONS.map(({ value, label }) => (
          <button
            key={value}
            onClick={() => onChange(value)}
            disabled={disabled}
            className={`
              px-3 py-1.5 text-sm rounded-md font-medium transition-colors
              ${selected === value
                ? 'bg-blue-600 text-white'
                : 'text-gray-300 hover:text-white hover:bg-gray-600'
              }
              ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
            `}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PeriodSelector;
